import { reportHandledException } from '@/lib/error-reporting'
/**
 * 讓 promise 與逾時賽跑:promise 先 settle → 回其值(並 clear timer);逾時先到 → 回 fallback。
 * `settled` 旗標保證只 resolve 一次(先到者贏,後到者被忽略)。promise reject 也當作 fallback
 * (呼叫端要區分成功/失敗時,自己在 promise 內把失敗編碼進值,而非靠 reject)。
 *
 * 用於「等一個可能吊死的非同步決定」的所有地方:PCM 啟動、begin 決定、等 WAV、mic acquire。
 */
export function raceWithTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number,
  fallback: T
): Promise<T> {
  return new Promise<T>((resolve) => {
    let settled = false
    const settle = (value: T) => {
      if (settled) return
      settled = true
      clearTimeout(timer)
      resolve(value)
    }
    const timer = setTimeout(() => settle(fallback), timeoutMs)
    void promise.then(settle).catch((caughtError) => {
      reportHandledException(caughtError, { source: 'lib/race-with-timeout.ts' })
      return settle(fallback)
    })
  })
}
